/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.0.1
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const RoutingLanguages = {
  BgBg: "bg-BG",
  CaEs: "ca-ES",
  CsCz: "cs-CZ",
  DaDk: "da-DK",
  DeDe: "de-DE",
  ElGr: "el-GR",
  EnGb: "en-GB",
  EnUsXPirate: "en-US-x-pirate",
  EnUs: "en-US",
  EsEs: "es-ES",
  EtEe: "et-EE",
  FiFi: "fi-FI",
  FrFr: "fr-FR",
  HiIn: "hi-IN",
  HuHu: "hu-HU",
  ItIt: "it-IT",
  JaJp: "ja-JP",
  NbNo: "nb-NO",
  NlNl: "nl-NL",
  PlPl: "pl-PL",
  PtBr: "pt-BR",
  PtPt: "pt-PT",
  RoRo: "ro-RO",
  RuRu: "ru-RU",
  SkSk: "sk-SK",
  SlSi: "sl-SI",
  SvSe: "sv-SE",
  TrTr: "tr-TR",
  UkUa: "uk-UA",
} as const;
export type RoutingLanguages =
  (typeof RoutingLanguages)[keyof typeof RoutingLanguages];

export function instanceOfRoutingLanguages(value: any): boolean {
  for (const key in RoutingLanguages) {
    if (Object.prototype.hasOwnProperty.call(RoutingLanguages, key)) {
      if (RoutingLanguages[key as keyof typeof RoutingLanguages] === value) {
        return true;
      }
    }
  }
  return false;
}

export function RoutingLanguagesFromJSON(json: any): RoutingLanguages {
  return RoutingLanguagesFromJSONTyped(json, false);
}

export function RoutingLanguagesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RoutingLanguages {
  return json as RoutingLanguages;
}

export function RoutingLanguagesToJSON(value?: RoutingLanguages | null): any {
  return value as any;
}

export function RoutingLanguagesToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): RoutingLanguages {
  return value as RoutingLanguages;
}
